import React from "react";

export const VendorProfileDetailContext = React.createContext(null);

export const useVendorProfileDetailContext = () => {
  const context = React.useContext(VendorProfileDetailContext);

  if (!context) throw new Error("Vendor Detail Context not provided!");

  return context;
};
